import createHistory from 'history/createBrowserHistory'

export default createHistory()


// WEBPACK FOOTER //
// ./src/actions/history.js